<template>
  <div v-if="lengthyBoi">
    <div v-if="!visible">
      <pre>
        {{firstChars}}
      </pre>
    </div>
    <div>
      <b-collapse v-model="visible" :id="collapseId">
        <pre>
          {{formattedText}}
        </pre>
      </b-collapse>
    </div>
    <div>
      <b-btn @click="() => this.visible = !this.visible">
        {{visible ? 'Hide' : 'Show More'}}
      </b-btn>
    </div>
  </div>
  <div v-else>
    <pre>
      {{formattedText}}
    </pre>
  </div>
</template>

<script>
export default {
  props: {
    id: Number,
    text: String,
  },
  data() {
    return {
      cutoffLength: 500,
      visible: false,
    };
  },
  computed: {
    collapseId() {
      return 'collapse-'+this.id;
    },
    lengthyBoi() {
      return !!this.text && this.text.length > this.cutoffLength;
    },
    firstChars() {
      return this.formattedText.slice(0, this.cutoffLength);
    },
    formattedText() {
      try {
        return '\n' + JSON.stringify(JSON.parse(this.text), undefined, 2);
      } catch (e) { }

      // I'm sorry
      let numSpaces = 0, spaces = "  ";
      let letters = Array.from(this.text.replace('&amp;', '&').replace(/>\s*</g, '><'));
      let closing = false, compressing = false;
      for (let i = 1; i < letters.length; i++) {
        if (letters[i] === '>') {
          if (closing) {
            if (letters[i + 1] !== '<') {
              letters[i] = `>\n${this.getSpaces(numSpaces, spaces)}`;
            }
          } else if (letters[i + 1] === '<') {
            if (letters[i + 2] === '/') {
              let replaceIndex = letters.indexOf('>', i + 2);
              letters.splice(i, replaceIndex - i + 1, ` />\n${this.getSpaces(numSpaces, spaces)}`);
              i += 3;
              continue;
            } else {
              letters[i] = `>${this.getSpaces(++numSpaces, spaces)}`;
            }
          } else {
            compressing = this.shouldCompress(letters, i);
            letters[i] = compressing ? '>' : `>\n${this.getSpaces(++numSpaces, spaces)}`;
          }
          closing = false;
        } else if (letters[i] === '<') {
          if (letters[i + 1] === '/') {
            closing = true;
            letters[i] = compressing ? '<' : `\n${this.getSpaces(--numSpaces, spaces)}<`;
            compressing = false;
          } else {
            letters[i] = `\n${this.getSpaces(numSpaces, spaces)}<`;
          }          
        }
      }
      return '\n' + letters.join('');
    },
  },
  methods: {    
    getSpaces(count, spaces) {
      let str = spaces;
      for (let i = 1; i < count; i++)
        str += spaces;
      return str;
    },
    shouldCompress(letters, i) {
      let maxLength = 25;
      for (let count = 0; count < maxLength; count++)
        if (letters[i + count] === '<' && letters[i + count + 1] === '/')
          return true;
      return false;
    },
  }
}
</script>

<style>
pre {
}
</style>



// WEBPACK FOOTER //
// src/components/it-info/ExpandableDetails.vue